const styles = {
    managedContainer: {
        flexDirection: {
            xs: 'column-reverse',
            md: 'row',
        },
        marginBottom: {
            xs: '8px',
            md: '16px',
            lg: '48px',
            xl: '80px',
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: {
            xs: '8px',
            md: '16px',
            lg: '48px',
            xl: '80px',
        },
        maxWidth: '744px',
    },
    sizedImage: {
        '& img, & svg': {
            height: {
                xs: '260px',
                sm: '283px',
                md: '100%',
            },
            maxHeight: '400px',
            maxWidth: '480px',
            verticalAlign: 'middle',
            width: {
                xs: '311px',
                sm: '340px',
                md: '100%',
            },
        },
    },
    innerContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: {
            xs: '80%',
            sm: '340px',
            md: '100%',
        },
        width: '340px',
    },
    displayText: {
        py: 1,
        px: 0,
    },
    inlinePara: {
        display: 'inline',
    },
    errorTitle: {
        marginBottom: '3px',
        marginTop: {
            xs: '56px',
            md: '0',
        },
    },
    headline: {
        fontSize: {
            xs: '1.75rem',
            sm: '2.25rem',
        },
        fontWeight: 700,
        lineHeight: {
            xs: '34px',
            sm: '42px',
        },
        mb: {
            xs: 0,
            sm: 2.625,
        },
        mt: {
            xs: 3,
            md: 5.25,
        },
    },
};
export default styles;
//# sourceMappingURL=data:application/json;base64,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